import { Fragment, Dispatch, ReactNode } from 'react';
import { Checkbox, styled } from '@mui/material';
import { formatDate, includes, mapRole, variables } from '../common';
import { ICert } from './types';
import { TeamRequestAction, certsAllSelected } from '.';
import { map as lmap } from 'lodash/fp';

export const UserRoles2d = ({
  certs,
  selectedKeys,
  enableAll,
  dispatchTeamRequest,
}: {
  certs: ICert[];
  selectedKeys: string[];
  enableAll: boolean;
  dispatchTeamRequest: Dispatch<TeamRequestAction>;
}) => (
  <Articl>
    <h4>
      {enableAll && (
        <Checkbox
          color="primary"
          onClick={() =>
            dispatchTeamRequest({ type: 'ToggleUserRole', payload: 'all' })
          }
          checked={certsAllSelected({
            certs,
            selectedKeys,
          })}
        />
      )}
    </h4>
    <h4>DEA Registration Number</h4>
    <h4>Serial Number</h4>
    <h4>Certificate Status</h4>
    <h4>Expiration Date</h4>
    <h4>Role</h4>
    <h4>First Name</h4>
    <h4>Last Name</h4>
    <h4>Email</h4>
    {lmap<ICert, ReactNode>(
      ({
        key,
        deaNumber,
        srNum,
        role,
        firstName,
        lastName,
        certificateEmail,
        certExpDt,
        appStatusDesc,
      }) => (
        <Fragment key={key}>
          <span>
            <Checkbox
              color="primary"
              onClick={() =>
                dispatchTeamRequest({
                  type: 'ToggleUserRole',
                  payload: key,
                })
              }
              checked={includes(selectedKeys)(key)}
            />
          </span>
          <span>{deaNumber}</span>
          <span>{srNum}</span>
          <span>{appStatusDesc}</span>
          <span>{certExpDt ? formatDate(new Date(certExpDt)) : null}</span>
          <span>{mapRole(role)}</span>
          <span>{firstName}</span>
          <span>{lastName}</span>
          <span>{certificateEmail}</span>
        </Fragment>
      )
    )(certs)}
  </Articl>
);

const Articl = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '1rem',
  },

  '@media (min-width: 60em)': {
    display: 'grid',
    gridTemplateColumns: '5.5rem repeat(8, auto)',
    gap: '1px',

    backgroundColor: variables.grayLighter,
    border: variables.cardBorder,
    borderRadius: variables.cardBorderRadius,

    '&>*': {
      backgroundColor: '#fff',
      padding: '1rem',
    },

    '&>*+*': {
      marginTop: '0rem',
    },
  },
}));
